import { Backdrop, Box, Modal } from '@mui/material';
import { AddCircleOutline, CheckCircleOutline } from '@mui/icons-material';
import AudioUploaderNonNativeAdmin from "components/NonNativeAdmin/audioUploaderNonNativeAdmin";
import VideoUploaderNonNativeAdmin from "components/NonNativeAdmin/videoUploaderNonNativeAdmin";
import AddDefinitionNonNativeAdmin from "components/NonNativeAdmin/addDefinitionNonNativeAdmin";
import React, { memo, useState } from "react";
import styled from "styled-components";
import { closeModal } from "utils/assets/images";

const style = {};

const LearnModalBg = styled.div`
  background: white;
  max-width: 383px;
  margin: 0 auto;
  margin-top: 115px;
  border-radius: 9px;
  padding: 55px 42px !important;
  user-select: none;
`;

const ModelDtl = styled.div`
  box-shadow: none;
`;

const hasMediaUrl = (v) =>
  !!(v !== undefined && v !== null && typeof v !== "object" && String(v).trim().length > 0);

const MEDIA_BACKDROP_Z_INDEX = 1299;
const MEDIA_SELECTION_MODAL_Z_INDEX = 1300;
const MEDIA_CHILD_MODAL_Z_INDEX = 1400;

const DefaultAudioGenerator = ({ openAllModal, handleCloseModal, handleClose, audioUrl, videoUrl, openAudioModal, openVideoModal, openDefinitionModal, setAudioModal, setVideoModal, setDefinitionModal, pageId, handleUpdateAudio, handleUpdateVideo, handleUpdateDefinition, resultRectangle }) => {
  const resolvedVideoMarked = hasMediaUrl(videoUrl) || hasMediaUrl(resultRectangle?.videoFile);
  const resolvedAudioMarked = hasMediaUrl(audioUrl) || hasMediaUrl(resultRectangle?.audioFile);
  const childModalOpen = openAudioModal || openVideoModal || openDefinitionModal;
  const handleCloseSelectionModal = () => {
    handleClose();
    handleCloseModal();
  };

  const mediaFlowOpen =
    openAllModal || openAudioModal || openVideoModal || openDefinitionModal;

  if (!mediaFlowOpen) {
    return null;
  }

  return (
    <>
      <Backdrop
        open={openAllModal}
        sx={{ zIndex: MEDIA_BACKDROP_Z_INDEX }}
      />
      {openAudioModal ? (
        <AudioUploaderNonNativeAdmin
          audioUrl={audioUrl}
          openAudioModal={openAudioModal}
          handleClose={handleClose}
          modalZIndex={MEDIA_CHILD_MODAL_Z_INDEX}
          hideModalBackdrop
          getUrl={(v) => {
            handleUpdateAudio(v)
          }}
        />
      ) : null}
      {openVideoModal ? (
        <VideoUploaderNonNativeAdmin
          videoUrl={videoUrl}
          openVideoModal={openVideoModal}
          handleClose={handleClose}
          pageId={pageId}
          modalZIndex={MEDIA_CHILD_MODAL_Z_INDEX}
          hideModalBackdrop
          getUrl={(v) => {
            handleUpdateVideo(v)
          }}
        />
      ) : null}
      {openDefinitionModal ? (
        <AddDefinitionNonNativeAdmin
          openDefinitionModal={openDefinitionModal}
          handleClose={handleClose}
          modalZIndex={MEDIA_CHILD_MODAL_Z_INDEX}
          hideModalBackdrop
          definitionText={resultRectangle?.definition}
          definitionWord={resultRectangle?.word}
          getDefinition={handleUpdateDefinition}
        />
      ) : null}
      <Modal
        open={openAllModal}
        hideBackdrop
        onClose={(_event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          handleCloseSelectionModal();
        }}
        disableEscapeKeyDown
        sx={{
          zIndex: MEDIA_SELECTION_MODAL_Z_INDEX,
          pointerEvents: childModalOpen ? 'none' : 'auto',
        }}
      >
        <Box
          sx={{
            ...style,
            visibility: childModalOpen ? 'hidden' : 'visible',
          }}
          className="modelCntntIner modalVideoPlay"
        >
          <LearnModalBg className="lernModalBg">
            <ModelDtl className="modelDtl">
              <div
                style={{ zIndex: 70, top: "-64px", right: "-50px" }}
                className="closeModelInfo closeVideoModal"
                onClick={handleCloseSelectionModal}
              >
                <img
                  style={{ height: "30px" }}
                  src={closeModal}
                  alt="Close"
                  onClick={handleCloseSelectionModal}
                />
              </div>
              <div>
                <div>
                  <p style={{fontSize:18, color:'black'}}>Select an Audio file or a Video file or Add Definition.</p>
                </div>
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom:'10px',
                  cursor: "pointer"
                }}
                onClick={() => setAudioModal(true)}>
                  <span className="iconsAV">
                    {resolvedAudioMarked ? <CheckCircleOutline style={{ color: "green", }} /> : <AddCircleOutline style={{ color: 'grey' }} />}
                  </span>
                  <h1 className="uploadAV">
                    Upload Audio File
                  </h1>
                </div>
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  marginBottom:'10px',
                }}
                onClick={() => setVideoModal(true)}>
                  <span className="iconsAV">
                    {resolvedVideoMarked ? <CheckCircleOutline style={{ color: "green", }} /> : <AddCircleOutline style={{ color: 'grey' }} />}
                  </span>
                  <h1 className="uploadAV">
                    Upload Video File
                  </h1>
                </div>
                 <div style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer"
                }}
                onClick={() => setDefinitionModal(true)}>
                  <span className="iconsAV">
                    {resultRectangle?.definition ? <CheckCircleOutline style={{ color: "green", }} /> : <AddCircleOutline style={{ color: 'grey' }} />}
                  </span>
                  <h1 className="uploadAV">
                    Add Definition
                  </h1>
                </div>
              </div>
            </ModelDtl>
          </LearnModalBg>
        </Box>
      </Modal>
    </>
  );
};

export default memo(DefaultAudioGenerator);
